const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaCategoria: [] 
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PRODUTO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'PRODUTO_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'PRODUTO_CATEGORIA_SELECT_LISTADO':
			return {
				...state,
				listaCategoria: action.payload.data
			};

        default:
            return state;
    }
}
